import { ModuleIOValueTypeEnum, ModuleInputKeyEnum, ModuleTemplateTypeEnum } from '../../constants';
import {
  FlowNodeInputTypeEnum,
  FlowNodeOutputTypeEnum,
  FlowNodeTypeEnum,
} from '../../node/constants';
import { FlowModuleTemplateType } from '../../types';
import { Input_Template_Switch } from '../input';
import { Output_Template_Finish } from '../output';

/**
 * 判断器模型
 */
export const TFJudgeModule: FlowModuleTemplateType = {
  templateType: ModuleTemplateTypeEnum.flowControl,
  name: '判断器',
  avatar: '/imgs/module/tfSwitch.svg',
  description: `根据传入的内容进行 True False 输出。默认情况下，当传入的内容为 false, undefined, null, 0, none 时，会输出 false。你也可以增加一些自定义的字符串来补充输出 false 的内容。非字符、非数字、非布尔类型，直接输出 True。`,
  inputs: [
    Input_Template_Switch,
    {
      type: FlowNodeInputTypeEnum.textarea,
      label: '任意内容输入',
      key: ModuleInputKeyEnum.tfJudgeValue,
      valueType: 'any',
      showTargetInApp: true,
      showTargetInPlugin: true,
      required: true,
    },
    {
      type: FlowNodeInputTypeEnum.select,
      label: '判断模式',
      key: ModuleInputKeyEnum.tfJudgeMode,
      required: true,
      showTargetInApp: false,
      showTargetInPlugin: false,
      valueType: 'string',
      list: [
        { label: '匹配判断', value: 'pattern' },
        { label: '数值判断', value: 'standardNumber' },
      ],
      value: 'standardNumber',
    },
    {
      type: FlowNodeInputTypeEnum.custom,
      label: '匹配条件',
      key: ModuleInputKeyEnum.tfJudgeOpNum,
      required: true,
      valueType: ModuleIOValueTypeEnum.numberCompare,
      showTargetInApp: false,
      showTargetInPlugin: false,
      list: [
        { label: '>', value: 'gt' },
        { label: '<', value: 'lt' },
        { label: '<=', value: 'le' },
        { label: '>=', value: 'ge' },
        { label: '==', value: 'eq' },
        { label: '!=', value: 'neq' },
      ],
    },
    {
      type: FlowNodeInputTypeEnum.custom,
      label: '匹配条件',
      key: ModuleInputKeyEnum.tfJudgePattern,
      required: true,
      valueType: ModuleIOValueTypeEnum.string,
      showTargetInApp: false,
      showTargetInPlugin: false,
      value: '',
    },
  ],
  outputs: [
    Output_Template_Finish,
    {
      key: 'true',
      label: 'True',
      targets: [],
      type: FlowNodeOutputTypeEnum.source,
      valueType: ModuleIOValueTypeEnum.boolean,
    },
    {
      key: 'false',
      label: 'False',
      targets: [],
      type: FlowNodeOutputTypeEnum.source,
      valueType: ModuleIOValueTypeEnum.boolean,
    },
  ],
  id: 'w90mfp',
  flowType: FlowNodeTypeEnum.tfJudge,
};
